export const GET_PAGES_SUCCESS = "GET_PAGES_SUCCESS"
export const CREATE_PAGE = "CREATE_PAGE"
export const CREATE_PAGE_SUCCESS = "CREATE_PAGE_SUCCESS"
export const CLEAR_LAST_CREATED_PAGE_ID = "CLEAR_LAST_CREATED_PAGE_ID"
export const CLEAR_ACTUAL_PAGE_ID = "CLEAR_ACTUAL_PAGE_ID"

